/* eslint-disable react/prop-types */

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import withRouter from "./withRouter"
import { Badge, Collapse } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";

import { Box } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

import {operations as routes} from "../routes/routeDefinition";
import { useSessionStore } from "../services/stores/sessionStore";
import { ping } from "../helpers/utils";
import { useQueryPingServer } from "../services/stores";

const initOpenRoutes = (location) => {
  /* Open collapse element that matches current url */
  const pathName = location.pathname;

  let _routes = {};

  routes.forEach((route, index) => {
    const isActive = pathName.indexOf(route.path) === 0;
    const isOpen = route.open;
    const isHome = route.containsHome && pathName === "/" ? true : false;

    _routes = Object.assign({}, _routes, {[index]: isActive || isOpen || isHome})
  });

  return _routes;
};

const SidebarCategory = withRouter(
  ({
    name,
    badgeColor,
    badgeText,
    icon: Icon,
    isOpen,
    children,
    onClick,
    location,
    to
  }) => {
    const getSidebarItemClass = path => {
      return location.pathname.indexOf(path) !== -1 ||
        (location.pathname === "/" && path === "/dashboard")
        ? "active"
        : "";
    };

    return (
      <li className={"sidebar-item " + getSidebarItemClass(to)}>
        <span
          data-toggle="collapse"
          className={"sidebar-link " + (!isOpen ? "collapsed" : "")}
          onClick={onClick}
          aria-expanded={isOpen ? "true" : "false"}
        >
          <Icon size={18} className="align-middle mr-3" />
          <span className="align-middle">{name}</span>
          {badgeColor && badgeText ? (
            <Badge color={badgeColor} size={18} className="sidebar-badge">
              {badgeText}
            </Badge>
          ) : null}
        </span>
        <Collapse isOpen={isOpen}>
          <ul id="item" className={"sidebar-dropdown list-unstyled"}>
            {children}
          </ul>
        </Collapse>
      </li>
    );
  }
);

const SidebarItem = withRouter(
  ({ name, badgeColor, badgeText, icon: Icon, location, to }) => {
    const getSidebarItemClass = path => {
      return location.pathname === path ? "active" : "";
    };

    return (
      <li className={"sidebar-item " + getSidebarItemClass(to)}>
        <NavLink to={to} className={(navData) => (navData.isActive ? 'sidebar-link active' : 'sidebar-link')}>
          {Icon ? <Icon size={18} className="align-middle mr-3" /> : null}
          {name}
          {badgeColor && badgeText ? (
            <Badge color={badgeColor} size={18} className="sidebar-badge">
              {badgeText}
            </Badge>
          ) : null}
        </NavLink>
      </li>
    );
  }
);

const Sidebar = ({ location, sidebar, layout, dispatch }) => {
  const [openRoutes, setOpenRoutes] = useState(() => initOpenRoutes(location));

  const currentFarm = useSessionStore((state) => state.currentFarm)
  const [statusColor, setStatusColor] = useState("text-danger")

  const toggle = index => {
    // Collapse all elements
    Object.keys(openRoutes).forEach(
      item => openRoutes[index] || setOpenRoutes(openRoutes => Object.assign({}, openRoutes, {[item]: false}))
    )
    
    // Toggle selected element
    setOpenRoutes(openRoutes => Object.assign({}, openRoutes, {[index]: !openRoutes[index]}));
  }
  
  const { data: pingResult,
          isLoading: isPingLoading,
          error: pingError } = useQueryPingServer();

  useEffect(() => {
    if (pingResult && !isPingLoading && !pingError) {
      setStatusColor("text-success")
    } else {
      setStatusColor("text-danger")
    }

  }, [pingResult, isPingLoading, pingError]);

  return (
    <nav
      className={
        "sidebar" +
        (!sidebar.isOpen ? " toggled" : "") +
        (sidebar.isSticky ? " sidebar-sticky" : "")
      }
    >
      <div className="sidebar-content">
        <PerfectScrollbar>
          <a className="sidebar-brand" href="/">
            <Box className="align-middle text-primary" size={24} />{" "}
            <span className="align-middle">TanSeeQ</span>
          </a>

          <ul className="sidebar-nav">
            {routes.map((category, index) => {
              return ( 
                <div key={'A'+index}>

                <React.Fragment key={'B'+index}>

                  {category.header &&
                      <li className="sidebar-header" style={{color:'limegreen'}} key={index}>{category.header}</li>
                  }

                  {category.children? (
                    <SidebarCategory
                      key={'ccsc'+index}
                      name={category.name }
                      badgeColor={category.badgeColor}
                      badgeText={category.badgeText}
                      icon={category.icon}
                      to={category.path}
                      isOpen={openRoutes[index]}
                      onClick={() => toggle(index)}
                    >
                      {
                      category.children.map((route, index) => (
                        (!route.hidden)?
                        <SidebarItem
                          key={'cscsh'+index}
                          name={route.name } 
                          to={route.path}
                          badgeColor={route.badgeColor}
                          badgeText={route.badgeText}
                        /> : <React.Fragment key={'Hidden1'+index} />
                      ))}
                    </SidebarCategory>
                  ) : (
                    (!category.hidden)?
                      <SidebarItem
                        key={'chsi'+index}
                        name={category.name}
                        to={category.path}
                        icon={category.icon}
                        badgeColor={category.badgeColor}
                        badgeText={category.badgeText}
                      /> : <React.Fragment key={'Hidden2'+index} />
                  )}

                </React.Fragment>
                </div>
              );
            })}
          </ul>

          {!layout.isBoxed && !sidebar.isSticky ? (
            <div className="sidebar-bottom d-none d-lg-block" key="a">
              <div className="media">
                <img
                  className="rounded-circle mr-3"
                  src={currentFarm?.imageURL}
                  width="40"
                  height="40"
                />
                <div className="media-body">
                  <h5 className="mb-1">{currentFarm?.farmName}</h5>
                  <div>
                    <FontAwesomeIcon
                      icon={faCircle}
                      color={statusColor}
                      className= {statusColor}
                    />{" "}
                    Online
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </PerfectScrollbar>
      </div>
    </nav>
  )
}

export default withRouter(
  connect(store => ({
    sidebar: store.sidebar,
    layout: store.layout,
    dispatch: store.dispatch
  }))(Sidebar)
);
